import React from 'react'
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles({
  //Map1
  //Connectivity Legend Colors
  colorsConnect: {
    background:
      "linear-gradient(#FDE725, #EDE418, #C7E020, #AADC32, #8FD744, #75D054, #5DC863, #47C16E, #35B779, #27AD81, #20A486, #1F9A8A, #21908C, #24868E, #287C8E, #2C7C8E, #31688E, #365D8D, #3B528B, #404688, #443A83, #472D7B, #481F70, #471164, #440154)",
    marginBottom: "5px",
  },
});

export default function Legend () {
  const classes = useStyles();

    return (
      <div>
        <div className="legend">
          <Grid container>
            <Grid item xs={12}>
              <p align="center">
                PVR
              </p>
            </Grid>
            <Grid item xs={5} className={classes.colorsConnect}>
              <div></div>
            </Grid>
            <Grid item xs={7}>
              <div>
                <div>
                  <span></span>
                  <span>High</span>
                  <span></span>
                </div>
                <div>
                  <span></span>
                </div>
                <div>
                  <span></span>
                </div>
                <div>
                  <span></span>
                </div>
                <div>
                  <span></span>
                </div>
                <div>
                  <span></span>
                </div>
                <div>
                  <span></span>
                  <span>Low</span>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    );
}

